import { useTheme } from '@/contexts/RADashboardThemeContext/hooks'
import CheckIcon from '@mui/icons-material/Check'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import React from 'react'

interface CardConfigToggleItemProps {
  label: string
  isVisible: boolean
  onToggle: () => void
}

const CardConfigToggleItem: React.FC<CardConfigToggleItemProps> = ({ label, isVisible, onToggle }) => {
  const theme = useTheme()
  return (
    <MenuItem
      onClick={onToggle}
      sx={{
        fontSize: '14px',
        color: theme.textPrimary,
        gap: 1,
        py: 0.75,
        '&:hover': { backgroundColor: theme.border },
      }}
    >
      <Box sx={{ width: 18, display: 'flex', alignItems: 'center' }}>
        {isVisible && <CheckIcon sx={{ fontSize: 16, color: theme.textPrimary }} />}
      </Box>
      {label}
    </MenuItem>
  )
}

export default CardConfigToggleItem
